import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import Editbtn from "../Skills/images/circum_edit.svg";
import { Pagination } from "react-bootstrap";
import deletebtn from "../Skills/images/material-symbols-light_delete-outline.svg";
import stepbtn from "../Skills/images/step_btn.svg";
import { baseURL } from "../../config";

const TemplateTable = () => {
  const [posts, setPosts] = useState({ templates: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedtemplates, setEditedTemplates] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/alltemplates`);
        console.log("Fetched data:", data);
        if (Array.isArray(data.templates)) {
          setPosts({ templates: data.templates });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    try {
      await axios.get(`${baseURL}/deletectemplate?id=${categoryToDelete}`);
      // const data = posts.templates.filter(template => template.id !== categoryToDelete);
      // setPosts({ templates: data.templates });
      setShowDeleteModal(false);
      window.location.href = `${baseURL}/createtemplate`;
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.templates.slice(indexOfFirstPost, indexOfLastPost);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Define handleCloseEditModal, handleCloseCommentModal, handleCloseViewModal functions
  const onRowClick = (catid) => {
    window.location = "/choosetemplateform?tid=" + catid;
  };
  const handleEdit = (templates) => {
    setEditedTemplates(templates);
  };

  const onRowDel = (tid) => {
    setShowDeleteModal(true);
    setCategoryToDelete(tid);
  };

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">Appraisal Template List</h4>
        </div>
        <div className="col-lg-6 text-end bg-white ">
          <a
            href="choosetemplateform"
            className="text-decoration-none text-white"
          >
            <button type="button" class="btn btn-danger rounded-pill">
              Create Template +
            </button>
          </a>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Grade Level</th>
            <th>Created By</th>
            <th>Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((templates, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{templates.gradename}</td>
              <td>{templates.createdby}</td>
              <td>{templates.createddate}</td>

              {/* Action buttons */}
              <td className="text-center">
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => onRowClick(templates.id)}
                >
                  <img src={Editbtn}></img>
                </ReactBootstrap.Button>
                {/* <ReactBootstrap.Button onClick={() => handleComment(skill)}>Comment</ReactBootstrap.Button> */}
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  variant="danger"
                  onClick={() => onRowDel(templates.id)}
                >
                  <img src={deletebtn}></img>
                </ReactBootstrap.Button>
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>
      <ReactBootstrap.Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            Confirm Deletion
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          <p className="text-danger fw-bold">
            Are you sure you want to delete this Template?
          </p>
          Deleting Template will also impact the Appraisals which are based on
          this template.
          <b>
            If there are no appraisals forthis template you can delete safely.
          </b>
        </ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer>
          <ReactBootstrap.Button
            variant="secondary"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </ReactBootstrap.Button>
          <ReactBootstrap.Button variant="danger" onClick={confirmDelete}>
            Delete
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>

      {/* Pagination */}
      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.templates.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default TemplateTable;
